/* GASSISA
=========================================================================================
* Descripcion: Otras acciones exclusivas para preventas portatil.
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revision   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 26/06/2026 | Lic. Jose Luis Aragon Cervantes  | Creacion de panel portatil independiente
* ---------------------------------------------------------------------------------------
*/

import { Button, Divider, Drawer, IconButton, Stack, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import NextPlanIcon from "@mui/icons-material/NextPlan";
import DeleteIcon from "@mui/icons-material/Delete";
import { useVentas } from "../../../context/Ventas/VentasContext";
import { useDoubleClickPrevention } from "../../../hooks/useDoubleClickPrevention";

export default function MnuOtherActionsPreventasPortatil() {
  const {
    openModalPreventa,
    handleCerrarMenuModalPreventa,
    handleAbrirModalRecuperarPreVentaFirma,
    handleClickEliminarPreVenta,
    handleClickEliminarPartidaPreVentas,
    partidaSeleccionadaPreventas,
    setVentaTotales,
    getVentaTotalesForm,
    setClienteForm,
  } = useVentas();
  const { isProcessing, executeWithProtection } = useDoubleClickPrevention();

  const eliminarPreventa = () => {
    executeWithProtection(() => {
      handleClickEliminarPreVenta();
      setVentaTotales(getVentaTotalesForm());
      setClienteForm({});
    });
    handleCerrarMenuModalPreventa();
  };

  return (
    <Drawer
      anchor="right"
      open={Boolean(openModalPreventa)}
      onClose={handleCerrarMenuModalPreventa}
      PaperProps={{ className: "preventas-portatil__other-actions" }}
    >
      <div className="preventas-portatil__other-header">
        <Typography variant="h6">Otras acciones</Typography>
        <IconButton onClick={handleCerrarMenuModalPreventa} aria-label="Cerrar"><CloseIcon /></IconButton>
      </div>
      <Divider />
      <Stack spacing={1} sx={{ p: 1.25 }}>
        <Button variant="text" startIcon={<NextPlanIcon />} onClick={() => {
          handleAbrirModalRecuperarPreVentaFirma();
          handleCerrarMenuModalPreventa();
        }}>Editar preventa</Button>
        <Button
          variant="text"
          color="error"
          startIcon={<DeleteIcon />}
          disabled={isProcessing || !partidaSeleccionadaPreventas?.idpartida}
          onClick={() => {
            executeWithProtection(() => handleClickEliminarPartidaPreVentas(partidaSeleccionadaPreventas.idpartida));
            handleCerrarMenuModalPreventa();
          }}
        >Eliminar partida</Button>
        <Button variant="text" color="error" startIcon={<DeleteIcon />} disabled={isProcessing} onClick={eliminarPreventa}>
          Eliminar preventa
        </Button>
      </Stack>
    </Drawer>
  );
}
